// Auto-update badge — visible ONLY when running under Electron.
// Listens to update-status events pushed by main.js.
import { useEffect, useState } from "react";
import { Download, RefreshCw, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { electron, isDesktop } from "@/utils/electron";

export function UpdateBadge() {
  const [state, setState] = useState(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!isDesktop) return;
    const off = electron.updater.onStatus((payload) => {
      setState(payload.state);
      if (payload.state === "downloading") {
        setProgress(Math.round(payload.progress?.percent || 0));
      }
      if (payload.state === "available") {
        toast.info(`Yeni sürüm mevcut: ${payload.info?.version}`);
      }
      if (payload.state === "downloaded") {
        toast.success(`Güncelleme indirildi (${payload.info?.version}). Uygulamayı yeniden başlatın.`);
      }
      if (payload.state === "error") {
        toast.error(`Güncelleme hatası: ${payload.message}`);
      }
    });
    return off;
  }, []);

  if (!isDesktop) return null;
  if (!state || state === "not-available" || state === "checking") return null;

  const handleInstall = () => electron.updater.install();

  if (state === "downloading") {
    return (
      <Button
        variant="ghost" size="sm"
        className="h-9 text-xs gap-1.5"
        data-testid="update-badge-downloading"
      >
        <RefreshCw className="h-3.5 w-3.5 animate-spin" />
        <span className="hidden sm:inline">Güncelleniyor {progress}%</span>
      </Button>
    );
  }
  if (state === "downloaded") {
    return (
      <Button
        onClick={handleInstall}
        variant="default" size="sm"
        className="h-9 text-xs gap-1.5"
        data-testid="update-badge-install"
      >
        <CheckCircle2 className="h-3.5 w-3.5" />
        <span className="hidden sm:inline">Yeniden başlat & Kur</span>
      </Button>
    );
  }
  if (state === "available") {
    return (
      <Button
        variant="ghost" size="sm"
        className="h-9 text-xs gap-1.5 text-amber-600"
        data-testid="update-badge-available"
        onClick={() => electron.updater.check()}
      >
        <Download className="h-3.5 w-3.5" />
        <span className="hidden sm:inline">Yeni sürüm</span>
      </Button>
    );
  }
  return null;
}
